window.Products.Clothing.ShirtBellacanvas6004 = function() {
};
window.Products.Clothing.ShirtBellacanvas6004.inherits(window.Products.Clothing.Shirt);
window.Products.Clothing.ShirtBellacanvas6004.dpi = 150;
window.Products.Clothing.ShirtBellacanvas6004.has_3d = true;
window.Products.Clothing.ShirtBellacanvas6004.id = 84;
window.Products.Clothing.ShirtBellacanvas6004.slug = 'shirt-bellacanvas-6004';
window.Products.Clothing.ShirtBellacanvas6004.syncColors = true;
window.Products.Clothing.ShirtBellacanvas6004.texturesLoaded = 0;
window.Products.Clothing.ShirtBellacanvas6004.texturesLoading = false;
window.Products.Clothing.ShirtBellacanvas6004.use_glb = true;

window.Products.Clothing.ShirtBellacanvas6004.prototype.handleColorOption = function(modelViewer, color){
	var me = modelViewer.product;

	var object = modelViewer.object;
	if(!object) return;

	if(!color) {
		if(modelViewer.inlab){
			$('#button_options_color').find('img').attr('src', $(this).find('img').attr('src'));
			$('#container_options_color, #button_options_color').removeClass('active');
			color = $(this).attr('for');
		} else {
			color = $('#productInfo-productOption-color').find('option:selected').attr('data-slug');
		}
	}

	var three_color = me.getColor(color);

	object.children[1].material.color = three_color;
	if(typeof me.insideObject !== "undefined") {
		object.children[me.insideObject].material.color = three_color;
	}

	me.updateThreeTexture(modelViewer);
	var three_intensity = 1.5;

	if(color == "athletic_heather"){
		three_intensity = 2.5;
	}

	object.children[me.outsideObject].material.aoMapIntensity = three_intensity;

	if(typeof me.insideObject !== "undefined") {
		object.children[me.insideObject].material.aoMapIntensity = three_intensity;
	}
};

window.Products.Clothing.ShirtBellacanvas6004.prototype.getColor = function(_name){
	colors = {
		"black": 0x171616,
		"navy": 0x2b2c47,
		"white": 0xffffff,
		"soft_cream": 0xffefd9,
		"true_royal": 0x2d4e95,
		"pink": 0xffe0e5,
		"deep_heather": 0x474543
	};

	return new THREE.Color(colors[_name]);
};